import { OrganizationIdentifierKindEnum } from '@e-socna/data-layer';
import { formatSiren, formatSiret } from '@e-socna/third-parties';

interface OrganizationIdentifierLike {
  readonly kind: OrganizationIdentifierKindEnum;
  readonly value: string;
}

export const getOrganizationIdentifierLabel = (
  identifier?: Pick<OrganizationIdentifierLike, 'kind'> | null,
): string =>
  identifier?.kind === OrganizationIdentifierKindEnum.Siret ? 'SIRET' : 'SIREN';

export const formatOrganizationIdentifierValue = (
  identifier?: OrganizationIdentifierLike | null,
): string | null => {
  if (!identifier) {
    return null;
  }

  return identifier.kind === OrganizationIdentifierKindEnum.Siret
    ? formatSiret(identifier.value)
    : formatSiren(identifier.value);
};
